import { render } from "./RegistrationRole.vue?vue&type=template&id=44d4a52e&scoped=true"
import script from "./RegistrationRole.vue?vue&type=script&lang=js"
export * from "./RegistrationRole.vue?vue&type=script&lang=js"

import "./RegistrationRole.vue?vue&type=style&index=0&id=44d4a52e&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d4a52e"]])

export default __exports__